import ProductsActions from "./products/actions";
import UserActions from "./users/actions";
import CatregoriesActions from "./categories/actions";
import BrandsActions from "./brands/actions";
import FlashSalesActions from "./flashSales/actions";
import SupplyActions from "./supply/actions";
import PlatformActions from "./platform/actions";
import BcfActions from "./bcf/actions";
import DataActions from "./data/actions";
import WholeSalesActions from "./wholeSales/actions";
import WHSettings from "./WHSettings/actions";
import ebay from "./ebay/action"
export const actions = {
  ...ProductsActions,
  ...UserActions,
  ...CatregoriesActions,
  ...BrandsActions,
  ...FlashSalesActions,
  ...SupplyActions,
  ...PlatformActions,
  ...BcfActions,
  ...DataActions,
  ...WHSettings,
  ...WholeSalesActions,
  ...ebay,
};
export const mutations = {};
export const state = {};
